export default "__VITE_ASSET__RHxdpd3F__"